import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { FaCheck } from "react-icons/fa";
import { UncontrolledTooltip } from "reactstrap";

const PaymentItem = ({ method, handleSelect, selectedMethod, selected }) => {
  const { t } = useTranslation();
  return (
    <a
      id={method.name}
      href='#/'
      onClick={(e) => method.active && handleSelect(e, method.name, method.logo)}
      className={clsx("mx-1 my-2 px-3 pt-2 pb-1 btn-input-select", { active: selected })}
    >
      {selected ? (
        <div className='selected-icon'>
          <FaCheck />
        </div>
      ) : null}
      {method.active ? (
        <>
          {method.logo}
          <div className='font-size-sm my-1'>{t("payname." + method.name)}</div>
        </>
      ) : (
        <div style={{ filter: "grayscale(100%)", opacity: 0.5 }}>
          {method.logo}
          <UncontrolledTooltip
            trigger='hover'
            popperClassName='tooltip-dark'
            placement='top'
            container='body'
            target={method.name}
          >
            {t("bank-unavaliable")}
          </UncontrolledTooltip>
          <div className='font-size-sm my-1'>{t("payname." + method.name)}</div>
        </div>
      )}
    </a>
  );
};

export default PaymentItem;
